import {
  rateCardQuery,
  useDeleteRateCardMutation,
} from "@common/api/rate-cards"
import { ConfirmDialog } from "@common/components/shared/confirm-dialog"
import { handleError } from "@common/utils"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"

export const Route = createFileRoute(
  "/_layout/settings/_panel/quoting/rate-cards/$rateCardId/archive",
)({
  component: ArchiveRateCardDialog,
})

function ArchiveRateCardDialog(): React.ReactElement {
  const { rateCardId } = Route.useParams()
  const { data: card } = useSuspenseQuery(
    rateCardQuery({ rate_card_id: rateCardId }),
  )
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const archiveMutation = useDeleteRateCardMutation()

  const close = () =>
    navigate({
      to: "/settings/quoting/rate-cards/$rateCardId",
      params: { rateCardId },
      search: true,
    })

  const confirm = () =>
    archiveMutation.mutate(
      { rate_card_id: rateCardId },
      {
        onSuccess: () => {
          showToast("Archived", `${card.name} archived.`, "success")
          navigate({ to: "/settings/quoting/rate-cards", search: true })
        },
        onError: (error) => handleError(error, showToast),
      },
    )

  return (
    <ConfirmDialog
      title={`Archive ${card.name}?`}
      description="Archived rate cards keep their history and appear in the Archived tab."
      action="Archive"
      tone="default"
      pendingAction="Archiving…"
      pending={archiveMutation.isPending}
      onConfirm={confirm}
      onCancel={close}
    />
  )
}
